<template>
  <!-- 查看属性弹窗 -->
  <el-dialog
    :title="titleDialog"
    :visible.sync="dialogVisible"
    :close-on-press-escape="false"
    @close="onHandleClose"
    width="600px"
    class="dialog"
    center
  >
    <div class="contents">
      <div class="d-flex mb-15">
        <div class="nameWrap">属性名称:</div>
        <div class="ml10">{{ detailInfo.field_key }}</div>
      </div>
      <div class="d-flex" style="align-items: self-start">
        <div class="nameWrap">属性值:</div>
        <div class="ml10 boxWrap" style="flex: 1">
          <div
            v-for="(dItem, dIndex) in detailInfo.field_map"
            :key="dIndex"
            class="mb-10"
          >
            {{ dItem }}
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "viewPropertiesDialog",
  props: {},
  data() {
    return {
      dialogVisible: false,
      titleDialog: "查看属性",
      detailInfo: {},
    };
  },
  methods: {
    /**
     * 初始化
     */
    async onInitData(data) {
      this.dialogVisible = true;
      console.log(data, "data==");
      this.detailInfo = data;
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #13ae67;

.dialog {
  .contents {
    padding-top: 30px;
    padding-bottom: 20px;
    .nameWrap {
      width: 100px;
      text-align: right;
    }
    .boxWrap {
      max-height: 400px;
      overflow: auto;
    }
  }
}
</style>
